module.exports = __webpack_public_path__ + "static/hexofy-logo-93ff715f1ba244ba204fa614fa3f729c.svg";